/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import CognitoService from '../../services/cognito';
import { GlobalPageActions } from '../../store/app.actions.index';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserPageActions } from '../actions/userActions/index';
import { of } from 'rxjs';

// import { AppActions as globalActions } from '../../store/app.reducer'

/* NgRx */

@Injectable()
export class AuthEffects {
  dispatchLoginErrorMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPageActions.LOGIN_SERVICE_ERROR),
      switchMap((action: any) => {
        this.store.dispatch({
          type: UserPageActions.SEND_GLOBAL_MESSAGE,
          payload: {
            message: action.payload.message,
          },
        });
        return of({ type: '[Auth] Login error message dispatched' });
      })
    ), { dispatch: false }
  );

  startLoginHttps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPageActions.REQUEST_LOGIN),
      mergeMap((action: UserPageActions.RequestLogin) =>
        this.localCognitoService.callLogin(action.payload.username, action.payload.password).pipe(
          switchMap((payload) => {
            if (payload.code === 'error') {
              return of(new UserPageActions.LoginServiceError(payload));
            } else {
              return [
                new UserPageActions.LoginServiceProcessing(payload),
                new GlobalPageActions.WriteJwtGlobally(payload),
              ];
            }
          }),
          catchError((error) => of(new UserPageActions.LoginServiceError(error)))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private localCognitoService: CognitoService
  ) {}
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
